import axios from "axios";
import {getToken} from "./userCredentials";

export const postOrder = async (booked) => {
    let res = await axios.post(process.env.VUE_APP_DB + "/api2/order/", booked,{headers: {"authorization": 'Bearer ' + await getToken()}});
    return res.status;
}

